class ResizeService {
    /**
     * Observe if the element resize and repaint when it is visible again, returns a dispose function
     * @param element
     * @param repaint
     * @returns
     */
    static createResizeObserverForComponent(element, repaint: Function, ignoreFirstResize?: boolean): Function {
        let disposeObserver: Function;
        let sub = (ko as any).bindingEvent.subscribe(element, 'descendantsComplete', function (node) {
            disposeObserver = ResizeService.createResizeObserver(element, repaint, ignoreFirstResize);
        });

        let dispose = function () {
            sub?.dispose();
            disposeObserver();
        }

        return dispose;
    }

    static createResizeObserver(element, repaint: Function, ignoreFirstResize?: boolean): Function {
        let visible = true;
        let resized = false;
        let firstResize = ignoreFirstResize;

        function resize() {
            if (firstResize) {
                firstResize = false;
                return;
            }

            //resize only if the element is visible
            if (visible) {
                repaint();
            }
            else {
                //set the element needs to be resized when visible again
                resized = true;
            }
        };

        let resizer = new ResizeObserver(irGlobal.debounce(resize, 300));
        resizer.observe(element);

        let callback = (entries, observer) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    //When the element is visible again, set as visible and repaint
                    visible = true;
                    if (resized) {
                        resized = false;
                        repaint();
                    }
                }
                else {
                    //When changing tabs, element will be invisible
                    visible = false;
                }
            });
        };

        //Observe the element visibility in the viewport
        let observer = new IntersectionObserver(callback);
        observer.observe(element);

        let dispose = function () {
            resizer?.disconnect();
            observer.disconnect();
        }

        return dispose;
    }
}